import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './redux/rootReducer'
// const initialState = {
//   sidebarShow: true,
//   count:0,
// }

// const changeState = (state = initialState, { type, ...rest }) => {
//   switch (type) {
//     case 'set':
//       return { ...state, ...rest }
//     default:
//       return state
//   }
// }

//const store = createStore(changeState)
const store = configureStore({
    reducer: rootReducer
  })
export default store
